import {RouteProps} from 'config/navigation';

import AdditionalGroups from './additional-groups';
import CreateAdditionalGroup from './create-additional-group';
import AdditionalGroupDetails from './additional-group-details';
import {FaLayerGroup} from 'react-icons/fa';
import CreateAdditional from './additional-group-details/components/create-additional';
import EditAdditional from './additional-group-details/components/edit-additional';

const additionalGroupsPages: RouteProps = {
  name: 'Grupo de adicionais',
  path: 'additional-groups',
  permission: 'additionalGroups.findAll',
  icon: <FaLayerGroup />,
  subRoutes: [
    {
      path: '',
      element: <AdditionalGroups />,
      permissions: ['additionalGroups.findAll'],
    },
    {
      path: 'create',
      element: <CreateAdditionalGroup />,
      permissions: ['additionalGroups.findOne'],
    },
    {
      path: ':id',
      element: <AdditionalGroupDetails />,
      permissions: ['additionalGroups.findOne'],
    },
    {
      path: ':id/additionals',
      element: <AdditionalGroupDetails activeTab="additionals" />,
      permissions: ['additionalGroups.findOne'],
      modals: [
        {path: 'create', element: <CreateAdditional />},
        {path: ':additionalId', element: <EditAdditional />},
      ],
    },
  ],
};

export default additionalGroupsPages;
